import { Map } from 'immutable';
import reducerChain from '../helpers/chain';
import Constants from '../../constants/index';

import { viewReducerMerger, viewReducerRemover } from '../helpers/views';

export const DEFAULT_STATE = Map({
	page: 0,
	hasMore: false,
	next: null,
});

const defaultAllTopics = viewReducerMerger(
	[
		Constants.FETCH_ALL_TOPICS,
		Constants.FETCH_MORE_TOPICS,
		Constants.FETCH_TOPIC_BY_NAME,
		Constants.FETCH_ALL_TOPICS_BY_NAME,
	],
	'topics',
);
const deletedTopics = viewReducerRemover(Constants.DELETE_TOPIC);

export default reducerChain([defaultAllTopics, deletedTopics], DEFAULT_STATE);
